import React from 'react'
import DashboardIcon from '@mui/icons-material/Dashboard';
import RssFeedOutlinedIcon from '@mui/icons-material/RssFeedOutlined';
import PersonIcon from '@mui/icons-material/Person';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AdminSideBar = () => {
    const navigate = useNavigate();
    const navBar = [
        {
            link: '/admin/dashboard',
            Icon: <DashboardIcon />,
            title: 'Dashboard'
        },
        {
            link: '/admin/blogs',
            Icon: <RssFeedOutlinedIcon />,
            title: 'Blogs'
        },
        {
            link: '/admin/users',
            Icon: <PersonIcon />,
            title: 'Users'
        }
    ]

  return (
    <nav className='p-4 flex-col bg-[#011539] py-[50px]' >
        {
            navBar?.map((nav, i) => {
                return (
                    <div key={i} className='pb-[10px] text-center' >
                        <Tooltip title={nav?.title}  >
                            <IconButton 
                            onClick={() => navigate(nav?.link)}
                            sx={{
                                color: "#fff"
                            }} >
                                {nav?.Icon}
                            </IconButton>
                        </Tooltip>
                    </div>
                )
            })
        }
    </nav>
  )
}

export default AdminSideBar